export default "__VITE_ASSET__BGLPJfMD__"